import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login, admin, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@btsc.bihar.gov.in");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (ready && admin) navigate("/admin", { replace: true });
  }, [ready, admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-page" data-testid="admin-login-page">
      <form className="login-card" onSubmit={submit} data-testid="admin-login-form">
        <div className="login-icon"><Lock size={24} /></div>
        <h1>Admin Login</h1>
        <p className="login-sub">Bihar Technical Service Commission</p>
        {error && <div className="login-error" data-testid="login-error">{error}</div>}
        <label>Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <label>Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Enter password" data-testid="login-password" />
        <button type="submit" disabled={busy} data-testid="login-submit">
          <LogIn size={16} /> {busy ? "Signing in..." : "Sign In"}
        </button>
        <button type="button" className="back-home" onClick={() => navigate("/")} data-testid="login-back-home">← Back to website</button>
      </form>
    </div>
  );
}
